import { SvgIconComponent } from '@mui/icons-material';
import { ButtonProps, IconButton, Tooltip } from '@mui/material';
import StyledIcon from './StyledIcon';

type TableActionButtonProps = ButtonProps & {
  Icon: SvgIconComponent;
};
const TableActionButton = ({ Icon, children, ...buttonProps }: TableActionButtonProps) => {
  const { title, ...restProps } = buttonProps;

  return (
    <Tooltip placement='top' title={title}>
      <IconButton
        sx={{
          p: { xs: 0.5, md: 1 },
          '&:hover': { backgroundColor: 'transparent' },
          ...restProps.sx,
        }}
        {...restProps}
      >
        <StyledIcon Icon={Icon} disabled={buttonProps.disabled} />
      </IconButton>
    </Tooltip>
  );
};

export default TableActionButton;
